jQuery(document).ready(function ($) {


    ;( function () {

        const $modal = $('.modal');

        const get_title = function() {
            return $(this).find('.modal-header .modal-title');
        };

        let $current_element = null;

        // Occurs when the modal is about to be shown
        $modal.on('show.bs.modal', function(){
            const $this = $(this);
            $current_element = $(`#${$this.attr('id')}`);
            get_title.call(this).attr('tabindex', '0');
        });

        // Occurs when the modal is fully shown (after CSS transitions have completed)
        $modal.on('shown.bs.modal', function(){
            setTimeout( _ => get_title.call(this).focus(), 0 );
        });

        $modal.on('hidden.bs.modal', function(){
            const $modal_title = get_title.call(this);
            $modal_title.removeAttr('tabindex');
            setTimeout( _ => $current_element.focus(), 0 );
        });

    })();
});